import { Component, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PagedTableComponent } from 'common/table/paged-table.component';
import { RevisionsEditingSupport } from 'component/details/revisions-editing-support';
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatTableModule,
} from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ChipComponent } from 'common/designsystem/chip/chip.component';
import { TableDataSource } from 'common/table/table-data-source';
import { ApiProductRevision } from 'api';
import { RouterLink } from '@angular/router';
import { IntakeTypeChipComponent } from 'common/designsystem/chip/intake-type-chip.component';

@Component({
  selector: 'comp-revisions-table',
  templateUrl: './revisions-table.component.html',
  styleUrl: './revisions-table.component.scss',
  imports: [
    TranslateModule,
    PagedTableComponent,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatTableModule,
    DatePipe,
    MatSortModule,
    ChipComponent,
    RouterLink,
    IntakeTypeChipComponent,
  ],
})
export class RevisionsTableComponent {
  readonly dataSource = input.required<TableDataSource<ApiProductRevision>>();
  readonly editingSupport = input.required<RevisionsEditingSupport | undefined>();

  readonly evidenceOpened = output<number>();

  protected openEvidence(id: number): void {
    this.evidenceOpened.emit(id);
  }
}
